export default __webpack_public_path__ + "static/media/Mark-2-3D-Model-00.9f661d71.jpg";